module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "chap-title"
  }, [_c('a', {
    attrs: {
      "id": "page4"
    }
  }), _vm._v("Red Sky at Night")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("If the sun rests in the notch")]), _vm._v(" "), _c('p', {
    staticClass: "noindents"
  }, [_vm._v("on that mountain ridge.")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/logo.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("If an old woman is scribbling.")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/logo.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("If an old man alone")]), _vm._v(" "), _c('p', {
    staticClass: "noindents"
  }, [_vm._v("in the breakfast room")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("at the Vagabond Executive")]), _vm._v(" "), _c('p', {
    staticClass: "noindents"
  }, [_vm._v("Motor Inn")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("doing crossword puzzles")]), _vm._v(" "), _c('p', {
    staticClass: "noindents"
  }, [_vm._v("beneath "), _c('span', {
    staticClass: "font-i"
  }, [_vm._v("The Early Show")])]), _vm._v(" "), _c('p', {
    staticClass: "noindents"
  }, [_vm._v("babble")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("continues.")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/logo.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("If the tree blooms pink")]), _vm._v(" "), _c('p', {
    staticClass: "noindents"
  }, [_vm._v("there will be more")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("than we can imagine")]), _vm._v(" "), _c('p', {
    staticClass: "noindents"
  }, [_vm._v("always,")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("extra promptings")]), _vm._v(" "), _c('p', {
    staticClass: "noindents"
  }, [_vm._v("of pure nothing")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("which we can neither")]), _vm._v(" "), _c('p', {
    staticClass: "noindents"
  }, [_vm._v("keep nor forget.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d14d36c6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/009_Chapter002.vue
// module id = 81
// module chunks = 0